import {
  FontSizes,
  Icon,
  Label,
  PrimaryButton,
  Separator,
  Spinner,
  SpinnerSize,
  Text
} from '@fluentui/react';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useBoolean } from '@fluentui/react-hooks';
import MedicalServiceMultiSelectorComponent, {
  SelectedMedicalServiceType
} from '../../MedicalServices/MedicalServiceSelector/MedicalServiceMultiSelectorComponent';
import { AvailableMedicalService } from '../../../models/Entities/MedicalServices/AvailableMedicalService';
import { PractitionerAssociationsMedicalService } from '../../../models/Entities/PractitionerAssociations/MedicalServices/PractitionerAssociationMedicalService';

// functions
import * as ComponentFunction from './PractitionerMedicalServiceAssociatedListFunctions';

////i18Next
import { useTranslation, Trans } from 'react-i18next';

// styles
import './PractitionerMedicalServiceAssociatedList.css';

export const PractitionerMedicalServiceAssociatedListComponent = (
  props: ComponentFunction.Props
) => {
  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);

  //useTranslation();
  const [t] = useTranslation()

  // useEffect(() => {
  //   if (!props.Practitioners) {
  //     props.GetAllPractitioners(1, 1000, undefined);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [props.PractitionerId]);

  useEffect(() => {
    props.GetMedicalServiceByPractitionerId(props.PractitionerId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.PractitionerId]);

  //event handlers

  const onAssociateMedicalService = (
    medicalService: AvailableMedicalService
  ) => {
    props.AssociateMedicalServiceToPractitioner({
      practitionerId: props.PractitionerId,
      medicalServiceId: medicalService.id
    });
  };

  const onDisassociateMedicalService = (
    medicalService: SelectedMedicalServiceType
  ) => {
    props.DisassociateMedicalServiceFromPractitionerByMedicalServiceId(
      props.PractitionerId,
      medicalService.medicalServiceId
    );
  };

  // Render blocks

  const LoadingBlock = (
    <div className="LoadingBlock">
      <Spinner size={SpinnerSize.large} label={t('practitionerMedicalServiceAssociated.renderBlock.loadingBlock')}/>
    </div>
  );

  const ControlsBlock = (
    <div className="ControlsBlock">
      <PrimaryButton
        iconProps={ComponentFunction.AddIcon}
        text={t('practitionerMedicalServiceAssociated.renderBlock.selectMedicalService')} 
        onClick={openPanel}
        className="actionButton"
      />
      <MedicalServiceMultiSelectorComponent
        isOpen={isOpen}
        openPanel={openPanel}
        dismissPanel={dismissPanel}
        SelectedServices={ComponentFunction.GetSelectedMedicalServices(
          props.MedicalServicesAssociated
        )}
        ErrorInformed={props.ErrorOnAssociate || props.ErrorOnDisassociate}
        ViewOnly3erPartyServices={undefined}
        onSelect={onAssociateMedicalService}
        onUnselect={onDisassociateMedicalService}
      />
    </div>
  );

  const MedicalInsuranceAssociatedBlock = (
    <div className="MedicalServiceAssociatedBlock">
      <ul>
        {props.MedicalServicesAssociated?.map(
          (medicalService: PractitionerAssociationsMedicalService) => (
            <li key={medicalService.id}>
              <Icon
                iconName="FollowUser"
                style={{ fontSize: FontSizes.size24 }}
              />
              <div>
                <Label style={{ fontSize: FontSizes.size16 }}>
                  {medicalService.medicalService.serviceNameReference}
                </Label>
                {medicalService.medicalService.available ? (
                  <Text>{medicalService.medicalService.comments}</Text>
                ) : (
                  <Text style={{ color: 'red' }}>
                    {t('practitionerMedicalServiceAssociated.ServiceAssociatedBlock.disabledMedicalService')} 
                  </Text>
                )}
              </div>
            </li>
          )
        )}
      </ul>
    </div>
  );

  const NoContentBlock = (
    <div className="NoData">
      <Separator />
      <label>{t('practitionerMedicalServiceAssociated.ServiceAssociatedBlock.medicalServiceProvide')}</label>
    </div>
  );

  return (
    <>
      {ControlsBlock}
      {props.IsLoading
        ? LoadingBlock
        : props.LoadedSuccessfully &&
          props.MedicalServicesAssociated?.length > 0
        ? MedicalInsuranceAssociatedBlock
        : NoContentBlock}
    </>
  );
};

export default connect(
  ComponentFunction.mapStateToProps,
  ComponentFunction.mapDispatchToProps
)(PractitionerMedicalServiceAssociatedListComponent as any);
